import React, { useState, useEffect, Fragment } from "react";

const Loader = () => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShow(false);
    }, 3000);

    return () => {
      clearTimeout(timeout);
    };
  }, [show]);

  return (
    <Fragment>
      {show && (
        <div className="loader">
          <div className="jumpy-bars">
            <div className="bar" id="bar1"></div>
            <div className="bar" id="bar2"></div>
            <div className="bar" id="bar3"></div>
            <div className="bar" id="bar4"></div>
            <div className="bar" id="bar5"></div>
            <div className="bar" id="bar6"></div>
            <div className="bar" id="bar7"></div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default Loader;
